import {Injectable} from '@angular/core';
import {WebConfigurationService} from '../web-configuration-module/web-configuration.service';

declare const $: any;

@Injectable()
export class ThemeChangerService {

  constructor(protected configurationService: WebConfigurationService) {
  }

  private themeWrapper = document.querySelector('body');

  setDefaultTheme(callback: () => void = () => {
  }) {
    $('#bootstrap-theme-css')
      .attr('href', this.configurationService.configuration.uriBootstrap)
      .attr('disabled', false)
      .on('load', callback);
  }

  setThemeFromUrl(themeUrl: string, callback: () => void = () => {
  }) {
    $('#bootstrap-theme-css')
      .attr('href', (this.configurationService.configuration.uriBootstrap + '?' + themeUrl.replace(/#/g, '%23')))
      .attr('disabled', false)
      .on('load', callback);
  }

  setCssVars(property: string, value: string) {
    this.themeWrapper.style.setProperty('--' + property, value);
  }

  resetCssVars() {
    const defaultValues = {
      blue: '#0CA1BC',
      indigo: '#6610f2',
      purple: '#6f42c1',
      pink: '#e83e8c',
      red: '#dc3545',
      orange: '#fd7e14',
      yellow: '#ffc107',
      green: '#28a745',
      teal: '#20c997',
      cyan: '#1c8ab8',

      primary: '#28cd28',
      secondary: '#6c757d',
      success: '#28a745',
      info: '#1c8ab8',
      warning: '#ffc107',
      danger: '#dc3545',
      light: '#f8f9fa',
      dark: '#343a40',
      bgColor: '#61e061'
    };

    // tslint:disable-next-line:forin
    for (const key in defaultValues) {
      this.setCssVars(key, defaultValues[key]);
    }
  }

  previewTheme(
    primary = '',
    secondary = '',
    success = '',
    info = '',
    warning = '',
    danger = '',
    light = '',
    dark = '',
    bgColor = ''
  ) {
    const quesyString = `primary=${primary}&` +
      `secondary=${secondary}&` +
      `success=${success}&` +
      `info=${info}&` +
      `danger=${danger}&` +
      `light=${light}&` +
      `dark=${dark}&` +
      `warning=${warning}&` +
      `bgColor=${bgColor}&`;
    $('#bootstrap-theme-css').attr('href', this.configurationService.configuration.uriBootstrap + '?' + quesyString.replace(/#/g, '%23'));
  }

  changeTheme(
    primary = '',
    secondary = '',
    success = '',
    info = '',
    warning = '',
    danger = '',
    light = '',
    dark = '',
    bgColor = ''
  ) {
    const queryString = `primary=${primary}&` +
      `secondary=${secondary}&` +
      `success=${success}&` +
      `info=${info}&` +
      `danger=${danger}&` +
      `light=${light}&` +
      `dark=${dark}&` +
      `warning=${warning}&` +
      `bgColor=${bgColor}&`;
    $('#bootstrap-theme-css').attr('href', this.configurationService.configuration.uriBootstrap + '?' + queryString.replace(/#/g, '%23'));
  }
}
